import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram } from "lucide-react";
import { Logo } from "../components/Logo";
import { api } from "../lib/api";

export default function Links() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/links-config").then((r) => setCfg(r.data)).catch(() => setCfg({ items: [] }));
  }, []);

  const heading = cfg?.heading || "Tiger Trailride at LSU.";
  const tagline = cfg?.tagline || "Soul. Service. Movement.";
  const bg = cfg?.background_image;
  const items = (cfg?.items || []).filter((i) => i.visible !== false);

  return (
    <div className="relative min-h-screen w-full overflow-hidden" data-testid="links-page">
      {bg && <img src={bg} alt="" aria-hidden className="absolute inset-0 w-full h-full object-cover grayscale-img" />}
      <div className="absolute inset-0 bg-paper/85 backdrop-blur-[2px]" />

      <div className="relative z-10 max-w-md mx-auto px-6 py-16 flex flex-col items-center min-h-screen">
        <div className="mb-8"><Logo className="h-12" /></div>

        <h1 className="font-serif text-4xl font-black text-ink text-center tracking-tight">{heading}</h1>
        <p className="font-sans text-ink/60 mt-3 mb-10 tracking-wide text-center">{tagline}</p>

        <div className="w-full space-y-3">
          {items.map((item) => {
            if (item.kind === "image") {
              return item.image_url ? (
                <img
                  key={item.id}
                  src={item.image_url}
                  alt={item.label || "Tiger Trailride"}
                  data-testid={`link-image-${item.id}`}
                  className="w-full rounded-2xl object-cover border border-ink/10"
                />
              ) : null;
            }
            const internal = item.url?.startsWith("/");
            const cls =
              "group w-full flex items-center justify-between px-6 py-4 rounded-full bg-paper border border-ink/15 text-ink font-sans font-medium hover:bg-trailride hover:text-white hover:border-trailride transition-all duration-300";
            const inner = (
              <>
                <span className="inline-flex items-center gap-2">
                  {/instagram/i.test(item.label || "") && <Instagram size={18} />}
                  {item.label}
                </span>
                <ArrowUpRight size={18} className="opacity-50 group-hover:opacity-100" />
              </>
            );
            return internal ? (
              <Link key={item.id} to={item.url} data-testid={`link-${item.id}`} className={cls}>{inner}</Link>
            ) : (
              <a key={item.id} href={item.url} target="_blank" rel="noopener noreferrer" data-testid={`link-${item.id}`} className={cls}>{inner}</a>
            );
          })}
        </div>

        <p className="font-sans text-xs text-ink/40 mt-12">© Tiger Trailride | LSU</p>
      </div>
    </div>
  );
}
